// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
// IMPORTANTE: Deberás reemplazar estos valores con los de tu proyecto Firebase
const firebaseConfig = {
    apiKey: "AIzaSyARUnui5mSdIOtQHwYY14VBP5kVQeGNqhM",
    authDomain: "sismo-5f75e.firebaseapp.com",
    projectId: "sismo-5f75e",
    storageBucket: "sismo-5f75e.firebasestorage.app",
    messagingSenderId: "179745448280",
    appId: "1:179745448280:web:74e32e5ac4bc6ee6ae852d",
    measurementId: "G-8HCK4GP68K"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export default app;